import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContentWithCards } from "../components/DialogContent";
import { TextInput } from "../components/TextInput";
import { DialogTitle } from "../components/DialogTitle";
import Typography from "@material-ui/core/Typography";
import SelectableTable from "../components/SelectableTable";
import { PaperCard } from "../components/PaperCard";
import Grid from "@material-ui/core/Grid";
import SelectOrganization from "../containers/SelectOrganization";
import { GlobalAccessCheckbox } from "../components/GlobalAccessCheckbox";

export const EditAppBundleDialog = ({
  onClose,
  onSave,
  saveAvaliable,
  selectedBundle,
  name,
  nameNotUnique,
  onNameChange,
  description,
  onDescriptionChange,
  apps: { managedApps, externalApps },
  selectedApps,
  onAppSelect,
  organizationKey,
  onOrganizationChange,
  globalAccess,
  onGlobalAccessChange
}) => {
  const headers = ["Included", "", "Title", "Package Name", "VR Type(s)"];
  return (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open spacing={0}>
      <DialogTitle
        onCancel={onClose}
        onSave={onSave}
        saveAvaliable={saveAvaliable}
        darkBg
      >
        Edit App Bundle: {selectedBundle.name}
      </DialogTitle>
      <DialogContentWithCards>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="caption">* Required Inputs</Typography>
              <TextInput
                label={nameNotUnique ? "Must be unique" : "Name"}
                value={name}
                onChange={onNameChange}
                error={nameNotUnique}
                required
              />
              <TextInput
                label="Description"
                value={description}
                multiline
                onChange={onDescriptionChange}
              />
              <br />
              <br />
              <SelectOrganization
                value={organizationKey}
                onChange={onOrganizationChange}
              />
              <br />
              <GlobalAccessCheckbox
                value={globalAccess}
                onChange={onGlobalAccessChange}
              />
            </PaperCard>
          </Grid>

          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="subtitle1">
                <b>Managed Apps</b>
              </Typography>
              <SelectableTable
                headers={headers}
                rows={managedApps}
                selected={selectedApps}
                onSelect={onAppSelect}
              />
            </PaperCard>
          </Grid>

          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="subtitle1">
                <b>External Apps</b>
              </Typography>
              <SelectableTable
                headers={headers}
                rows={externalApps}
                selected={selectedApps}
                onSelect={onAppSelect}
              />
            </PaperCard>
          </Grid>
        </Grid>
      </DialogContentWithCards>
    </Dialog>
  );
};
